import React, { useState } from 'react';
import type { ActiveBillingCycleItem } from '../../services/api/types.gen';
import ClaimWorksheetEditor from './ClaimWorksheetEditor';
import { ClaimWorksheetActionButton } from './ClaimWorksheetActionButton';

const terminalStatuses = new Set(['PAID', 'CANCELLED']);

export const ClaimWorksheetViewerAction: React.FC<{
  billingCycle: ActiveBillingCycleItem;
}> = ({ billingCycle }) => {
  const [open, setOpen] = useState(false);
  const terminal = terminalStatuses.has(billingCycle.billing_cycle_status);
  return (
    <>
      <ClaimWorksheetActionButton
        onClick={() => setOpen(true)}
        label={terminal ? 'View claim worksheet' : 'Edit claim worksheet'}
      />
      {open && (
        <ClaimWorksheetEditor
          billingCycle={billingCycle}
          readOnly={terminal}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
};
